import React from "react";
import { Header } from "../../components/common/Header.js";
import { MovieTag } from "../../features/MovieTag/MovieTag.js";
import { MovieTagCarousel } from "../../features/MovieTag/MovieTagCarousel.js";
import { MovieTagList } from "../../features/MovieTag/MovieTagList.js";
import { NavLink } from "react-router-dom";

import { useDispatch } from "react-redux";
import { getDetail } from "../DetailsPage/DetailSlice.js";

import { SideBar } from "../../features/SideBar/SideBar.js";
import "./LandingPage.css";

//Test image 
import baftaImage from "../../resources/Images/bafta.png";

export const LandingPage = () => {
  const sampleDetailData = {
    adult: false,
    backdrop_path: "/foFq1RZWQIgFuCQ0nyYccywjFyX.jpg",
    belongs_to_collection: null,
    budget: 5740000,
    genres: [
      {
        id: 18,
        name: "Drama",
      },
      {
        id: 10749,
        name: "Romance",
      },
    ],
    homepage: "https://mk2films.com/en/film/portrait-of-a-lady-on-fire/",
    id: 531428,
    imdb_id: "tt8613070",
    original_language: "fr",
    original_title: "Portrait de la jeune fille en feu",
    overview:
      "On an isolated island in Brittany at the end of the eighteenth century, a female painter is obliged to paint a wedding portrait of a young woman.",
    popularity: 29.465,
    poster_path: "/2LquGwEhbg3soxSCs9VNyh5VJd9.jpg",
    production_companies: [
      {
        id: 43649,
        logo_path: "/5pv3tUlq25IiuMuok57YBZIiKn.png",
        name: "Lilies Films",
        origin_country: "FR",
      },
      {
        id: 94,
        logo_path: "/huC7HqorvUThGIrENrbcHmQVUA0.png",
        name: "ARTE France Cinéma",
        origin_country: "FR",
      },
      {
        id: 7980,
        logo_path: null,
        name: "Hold Up Films",
        origin_country: "FR",
      },
    ],
    production_countries: [
      {
        iso_3166_1: "FR",
        name: "France",
      },
    ],
    release_date: "2019-06-17",
    revenue: 9923127,
    runtime: 120,
    spoken_languages: [
      {
        english_name: "Italian",
        iso_639_1: "it",
        name: "Italiano",
      },
      {
        english_name: "French",
        iso_639_1: "fr",
        name: "Français",
      },
    ],
    status: "Released",
    tagline: "Don't regret. Remember.",
    title: "Portrait of a Lady on Fire",
    video: false,
    vote_average: 8.181,
    vote_count: 2176,
  };
  
  return (
    <div className="landing-page">
      <>
        <Header />
        <main className="landing_main">
          <h1 className="landing_title">I GUESS YOU LIKE CINEMA...</h1>

          <div className="site_instructions">
            <h2 className="instructions_title">Site Instructions</h2>

            <div className="instruction_section">
              <h3 className="section_title">Want to watch a movie or show?</h3>
              <p className="instruction_text">
                Head to <NavLink to="/search" className="instruction_link">Search</NavLink> and type in the name of the movie or show you'd like to watch.
                Please wait a moment for the search results to load.
              </p>
              <p className="instruction_note">
                <strong>Note:</strong> The search engine works best with English titles. However, it also supports titles in other languages—just allow a bit more time for results, or try the English name for faster searching.
              </p>
            </div>

            <div className="instruction_section">
              <h3 className="section_title">Don't know what to watch?</h3>
              <p className="instruction_text">
                Visit <NavLink to="/recommendation" className="instruction_link">Recommendations</NavLink> to discover award-winning films, famous collections, or see what's trending right now!
              </p>
            </div>

            <div className="instruction_section">
              <h3 className="section_title">Want something specific?</h3>
              <p className="instruction_text">
                Looking for something specific but don't want to browse randomly? Visit our <NavLink to="/filter" className="instruction_link">Filter</NavLink> page to pick from a variety of genres, time periods, regions, or try out the keyword search for results that better match your taste!
              </p>
            </div>

            <div className="instruction_section">
              <h3 className="section_title">How to watch</h3>
              <ul className="instruction_list">
                <li>Click the <strong>Verify</strong> button to open the video player</li>
                <li>For TV shows: Browse the season list, select your desired season, pick an episode, then click <strong>"Go to Episode"</strong></li>
                <li>Please allow time for resources to load, or re-click "Go to Episode" to navigate between episodes</li>
              </ul>
            </div>

            <div className="instruction_section subtitle_note">
              <p className="instruction_text">
                <strong>Language Support:</strong> Currently, we only support Vietnamese subtitles. We're working on adding more language options in the future!
              </p>
            </div>

            <div className="instruction_section mobile_note">
              <p className="instruction_text">
                <strong>Note:</strong> For the best experience, we recommend using a desktop browser. We're currently working on a mobile version and will ship it soon!
              </p>
            </div>
          </div>
        </main>
      </>
      <SideBar />
    </div>
  );
};


